import { EConditionType } from '../../../../json_query';
import { IOfficeConditionsTag } from '../../../state/tags/definitions/office_condition';
import { getMultiSelectionParamTagItem } from './fabrics/multi_selection_param_tag';

const officeConditionMap = {
  [EConditionType.OfficeDecoration]: 'Офисная отделка',
  [EConditionType.FullDecorationNeeded]: 'Под чистовую отделку',
  [EConditionType.MajorRepairNeeded]: 'Требуется капитальный ремонт',
  [EConditionType.CosmeticRepairNeeded]: 'Требуется косметический ремонт',
  [EConditionType.RegularRepair]: 'Типовой ремонт',
};

export const OfficeConditionTypesTagItem = getMultiSelectionParamTagItem<EConditionType, IOfficeConditionsTag>(
  officeConditionMap,
);
